import { useQuery } from "@apollo/client";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { InboundDeliveriesCountQuery } from "../../../graphql/deliveryService/queries/inboundDeliveriesCount";
import { InboundDeliveriesCountQueryVariables } from "../../../models/autogenerated-deliveryService-gql/graphql";
import { handleError } from "../../../utils/graphqlHelper";

interface useInboundDeliveriesCountsQueryProps {
  variables: InboundDeliveriesCountQueryVariables;
  dataAction: (count: number) => void;
  errorAction?: () => void;
}

const useInboundDeliveriesCountsQuery = (
  props: useInboundDeliveriesCountsQueryProps,
) => {
  const { t } = useTranslation();
  const { variables, dataAction, errorAction } = props;

  const query = useQuery(InboundDeliveriesCountQuery, {
    variables,
    fetchPolicy: "network-only",
  });

  const { data, error } = query;

  const inboundDeliveriesCount = data?.countInboundDeliveries;

  useEffect(() => {
    if (!error) return;

    handleError(t("inboundDeliveriesCountError"), error.message, errorAction);
  }, [error]);

  useEffect(() => {
    if (!data || !inboundDeliveriesCount) return;

    dataAction(inboundDeliveriesCount);
  }, [data]);

  return query;
};

export default useInboundDeliveriesCountsQuery;
